import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Lipoma Surgery Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, DNB - General Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Minimally Invasive Surgery Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Lump Removal Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Cosmetic Removal Expert"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Lipoma Care"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MCh - Plastic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Scarless Removal Techniques"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Lipoma Surgery Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert care for lipoma removal with advanced surgical techniques and minimal scarring.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const LipomaSurgeryTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Comprehensive Lipoma Surgery Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Advanced Lipoma Removal with 98% Success Rate. Minimally Invasive Techniques for Fast Recovery.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Emergency Lump Evaluation
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1 in 1000</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>People Affected</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>98%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Success Rate</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15-45</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Minutes Procedure</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-2</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Recovery</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "symptoms", label: "Symptoms", icon: "🔍" },
              { id: "types", label: "Types", icon: "🎯" },
              { id: "diagnosis", label: "Diagnosis", icon: "🔬" },
              { id: "treatment", label: "Treatment", icon: "⚕️" },
              { id: "recovery", label: "Recovery", icon: "🔄" },
              { id: "prevention", label: "Prevention", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Lipoma Surgery Treatment</span>
            </h2>
          </div>

          {/* What is Lipoma */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Lipomas
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                Lipomas are benign (non-cancerous) fatty tumors that grow slowly under the skin. They are the most common 
                soft tissue tumors and are composed of fat cells enclosed in a thin fibrous capsule. Lipomas are typically 
                soft, movable, and painless, and can occur anywhere on the body where fat cells are present.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Benign Nature</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Lipomas are almost always harmless and rarely turn cancerous. They grow slowly over 
                      months or years and typically don't cause health problems.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Common Condition</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Lipomas affect approximately 1% of the population and can occur at any age, 
                      though they're most commonly diagnosed between ages 40-60.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Symptoms and Characteristics */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Lipoma Symptoms & Characteristics
            </h3>

            <div className="row">
              {[
                {
                  title: "Soft & Doughy Texture", 
                  description: "Feels soft and rubbery to touch, easily movable under the skin",
                  details: "Characteristic feature that helps distinguish from other lumps"
                },
                {
                  title: "Slow Growth", 
                  description: "Gradual enlargement over months or years, typically 2-3 cm in size",
                  details: "Rapid growth may indicate different type of tumor"
                },
                {
                  title: "Painless Mass", 
                  description: "Usually painless unless pressing on nerves or blood vessels",
                  details: "Painful lipomas require medical evaluation"
                },
                {
                  title: "Well-Defined Borders", 
                  description: "Clear, distinct edges that can be felt during examination",
                  details: "Helps in surgical removal with clean margins"
                },
                {
                  title: "Skin Color Normal", 
                  description: "Overlying skin appears normal without redness or inflammation",
                  details: "Skin changes may indicate infection or malignancy"
                },
                {
                  title: "Multiple Locations", 
                  description: "Can occur as single or multiple lumps in various body areas",
                  details: "Multiple lipomas may indicate genetic condition"
                }
              ].map((symptom, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {symptom.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {symptom.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {symptom.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Lipoma Types */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Types of Lipomas
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Conventional Lipoma",
                    description: "Most common type composed of white fat cells in fibrous capsule",
                    treatment: "Simple excision, Minimal scar techniques"
                  },
                  {
                    type: "Angiolipoma",
                    description: "Contains blood vessels along with fat cells, may be painful",
                    treatment: "Careful surgical removal, May require additional hemostasis"
                  },
                  {
                    type: "Fibrolipoma",
                    description: "Contains fibrous tissue along with fat cells, feels firmer",
                    treatment: "Surgical excision, May require wider margins"
                  },
                  {
                    type: "Spindle Cell Lipoma",
                    description: "Contains spindle-shaped cells, typically in neck/shoulders",
                    treatment: "Complete surgical removal, Lower recurrence risk"
                  },
                  {
                    type: "Pleomorphic Lipoma",
                    description: "Contains cells of varying shapes and sizes, usually in older men",
                    treatment: "Wide local excision, Careful pathological examination"
                  },
                  {
                    type: "Atypical Lipoma",
                    description: "Deep-seated lipomas with potential for local recurrence",
                    treatment: "Marginal excision, Close follow-up monitoring"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Causes and Risk Factors */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Causes & Risk Factors
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Primary Causes</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Genetic predisposition and family history</li>
                      <li style={{ marginBottom: "10px" }}>Minor injuries that trigger fat cell growth</li>
                      <li style={{ marginBottom: "10px" }}>Chromosomal abnormalities in some cases</li>
                      <li style={{ marginBottom: "10px" }}>Adipose tissue dysplasia</li>
                      <li>Hormonal factors and metabolic conditions</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Risk Factors</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Age between 40-60 years</li>
                      <li style={{ marginBottom: "10px" }}>Family history of lipomas</li>
                      <li style={{ marginBottom: "10px" }}>Certain genetic conditions (Gardner's syndrome)</li>
                      <li style={{ marginBottom: "10px" }}>Obesity and overweight</li>
                      <li>Liver disease and diabetes in some cases</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Management
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    Many small, asymptomatic lipomas don't require immediate treatment and can be managed 
                    with observation. Regular monitoring ensures any changes in size or characteristics 
                    are detected early.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Conservative Approaches:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Regular monitoring and observation</li>
                          <li style={{ marginBottom: "8px" }}>Lifestyle modifications</li>
                          <li style={{ marginBottom: "8px" }}>Avoiding trauma to the area</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Pain management if needed</li>
                          <li style={{ marginBottom: "8px" }}>Cosmetic camouflage</li>
                          <li style={{ marginBottom: "8px" }}>Periodic ultrasound evaluation</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>When to Consider Treatment:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Rapid growth or size change</li>
                      <li style={{ marginBottom: "8px" }}>Pain or discomfort</li>
                      <li style={{ marginBottom: "8px" }}>Cosmetic concerns</li>
                      <li>Functional impairment or nerve compression</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical & Interventional Options
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Simple excision under local anesthesia</li>
                      <li style={{ marginBottom: "10px" }}>Minimal scar techniques</li>
                      <li style={{ marginBottom: "10px" }}>Liposuction-assisted removal</li>
                      <li style={{ marginBottom: "10px" }}>Endoscopic removal for deep lipomas</li>
                      <li>Laser excision for cosmetic areas</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Steroid injections for small lipomas</li>
                      <li style={{ marginBottom: "10px" }}>Lipolysis (fat-dissolving) injections</li>
                      <li style={{ marginBottom: "10px" }}>Radiofrequency ablation</li>
                      <li style={{ marginBottom: "10px" }}>Cryolipolysis (fat freezing)</li>
                      <li>Laser lipolysis</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Procedure Selection:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Based on lipoma size, location and type</li>
                      <li style={{ marginBottom: "10px" }}>Patient's cosmetic concerns</li>
                      <li>Recovery time and scar considerations</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Details */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Pre-Op",
                    title: "Preparation",
                    activities: ["Medical evaluation", "Blood tests", "Local anesthesia", "Marking incision site"]
                  },
                  {
                    period: "Surgery",
                    title: "Procedure",
                    activities: ["15-45 minutes", "Small incision", "Complete removal", "Cosmetic closure"]
                  },
                  {
                    period: "Week 1",
                    title: "Initial Recovery",
                    activities: ["Stitch care", "Pain management", "Limited activity", "Wound monitoring"]
                  },
                  {
                    period: "Week 2-4",
                    title: "Healing Phase",
                    activities: ["Suture removal", "Scar care", "Activity resume", "Final results"]
                  }
                ].map((phase, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {phase.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {phase.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {phase.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Results & Benefits */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Expected Results & Benefits
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Physical Results</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Complete removal of the lump</li>
                      <li style={{ marginBottom: "10px" }}>Minimal scarring with proper technique</li>
                      <li style={{ marginBottom: "10px" }}>Immediate relief from discomfort</li>
                      <li>Permanent solution in most cases</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Benefits</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Elimination of cosmetic concerns</li>
                      <li style={{ marginBottom: "10px" }}>Relief from pain or discomfort</li>
                      <li style={{ marginBottom: "10px" }}>Peace of mind from definitive diagnosis</li>
                      <li>Improved quality of life and confidence</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Is lipoma surgery painful?",
                  answer: "Lipoma surgery is typically performed under local anesthesia, which means you'll be awake but the area will be completely numb. You may feel some pressure or movement during the procedure, but no pain. After surgery, most patients experience only mild discomfort that can be managed with over-the-counter pain relievers. The incision site may be tender for a few days, and there might be some bruising or swelling. We provide detailed post-operative care instructions to ensure a comfortable recovery. Most patients return to their normal activities within a day or two, with only minor restrictions on strenuous exercise for about a week."
                },
                {
                  question: "Can lipomas come back after surgery?",
                  answer: "When a lipoma is completely removed through surgical excision, the recurrence rate is very low - typically less than 5%. The key to preventing recurrence is complete removal of the lipoma along with its fibrous capsule. However, it's important to understand that while the specific removed lipoma won't grow back, new lipomas can develop in other areas of the body, especially in individuals who are prone to developing multiple lipomas. Incomplete removal or rupture of the capsule during surgery can lead to recurrence in the same location. Our surgeons are experienced in ensuring complete removal while preserving the capsule integrity to minimize recurrence risk. We also provide guidance on monitoring for new lipomas during follow-up visits."
                },
                {
                  question: "How long is the recovery after lipoma surgery?",
                  answer: "Recovery from lipoma surgery is generally quick and straightforward. Most patients can return to normal daily activities within 24-48 hours. Stitches are typically removed in 7-14 days, depending on the location and size of the incision. You'll need to avoid strenuous exercise, heavy lifting, and swimming for about 2 weeks to allow proper healing. The incision will continue to heal and the scar will mature over several months. While the immediate results are visible right after surgery, the final cosmetic outcome with minimal scarring becomes apparent after 3-6 months. We provide specific aftercare instructions including wound care, activity restrictions, and scar management techniques to ensure optimal healing and cosmetic results."
                },
                {
                  question: "What's the difference between lipoma and liposarcoma?",
                  answer: "Lipomas and liposarcomas are fundamentally different types of tumors. Lipomas are benign (non-cancerous) fatty tumors that grow slowly, are usually soft and movable, and are very common. Liposarcomas, on the other hand, are malignant (cancerous) tumors that grow rapidly, may feel firm or fixed to deeper tissues, and are quite rare. While lipomas almost never turn into liposarcomas, any rapidly growing lump, especially one that is hard, fixed, painful, or larger than 5 cm, should be evaluated carefully. We perform thorough examinations and may recommend imaging studies like ultrasound or MRI to distinguish between these conditions. When there's any doubt, we perform a biopsy or complete excision with pathological examination to confirm the diagnosis."
                },
                {
                  question: "Do all lipomas need to be removed?",
                  answer: "No, not all lipomas require removal. Many small, asymptomatic lipomas can be safely monitored without intervention. We typically recommend removal in the following situations: When the diagnosis is uncertain and we need to rule out other conditions; If the lipoma is growing rapidly; When it causes pain, discomfort, or functional limitations; If it's located in an area where it's frequently irritated by clothing or movement; For cosmetic reasons when the appearance bothers the patient; When the lipoma is very large (usually over 5 cm); If it's pressing on nerves or blood vessels. During consultation, we assess each case individually and discuss the benefits and risks of removal versus observation to help you make an informed decision."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Concerned About a Lump or Bump?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert team provides comprehensive lipoma evaluation and removal with minimal scarring and fast recovery.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Lipoma Consultation
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              General Surgery: <strong>080-6541-7705</strong> | Emergency Evaluation: <strong>080-6541-7706</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default LipomaSurgeryTreatment;